import {
    BlockControls,
    MediaUpload,
} from '@wordpress/block-editor';
import { ToolbarButton, ToolbarGroup } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import React from 'react';

interface ControlsProps {
    attributes: {
        attachmentIds?: number[];
        attachmentUrls?: string[];
    };
    setAttributes: (attributes: Record<string, any>) => void;
}

const Controls: React.FC<ControlsProps> = ({
    attributes: { attachmentIds = [], attachmentUrls = [] },
    setAttributes,
}) => {
    const onSelectFiles = (media) => {
        // media kann ein Array oder ein einzelnes Objekt sein
        const files = Array.isArray(media) ? media : [media];
        const ids = files.map(file => file.id);
        const urls = files.map(file => file.url);
        setAttributes({
            attachmentIds: ids,
            attachmentUrls: urls,
        });
    };

    return (
        <BlockControls>
            <ToolbarGroup>
                <MediaUpload
                    onSelect={onSelectFiles}
                    allowedTypes={['application/pdf']}
                    multiple
                    value={attachmentIds}
                    render={({ open }) => (
                        <ToolbarButton
                            icon="download"
                            label={__('Anhänge auswählen', 'neodigital')}
                            onClick={open}
                        />
                    )}
                />
            </ToolbarGroup>
        </BlockControls>
    );
};

export default Controls;
